import { render, staticRenderFns } from "./site-footer.html?vue&type=template&id=0c412e6f&scoped=true&"
import script from "./site-footer.js?vue&type=script&lang=js&"
export * from "./site-footer.js?vue&type=script&lang=js&"
import style0 from "./site-footer.scss?vue&type=style&index=0&id=0c412e6f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c412e6f",
  null
  
)

export default component.exports